module.exports = __webpack_public_path__ + "static/media/contentfeedback.52e95959.gif";